import { Link } from "react-router-dom";
import { Mail, Phone, Instagram, Youtube } from "lucide-react";
import WhatsAppCallout from "./WhatsAppCallout";

const Footer = () => {
  return (
    <footer className="bg-black border-t border-[#1A1A1A]" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 pt-14 pb-12">
        {/* WhatsApp Callout */}
        <div className="mb-14">
          <WhatsAppCallout />
        </div>

        {/* Main Footer Content */}
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <Link to="/" className="inline-block mb-6">
              <span className="font-display text-2xl text-white tracking-wide" style={{ fontFamily: "'Bebas Neue', sans-serif" }}>
                CAMP CORMIER
              </span>
              <span className="block text-[10px] tracking-[0.4em] text-[#D4AF37] uppercase">
                Academy
              </span>
            </Link>
            <p className="text-white/50 text-sm leading-relaxed">
              Elite coaching for serious athletes. Transform your physique with 40+ years of professional bodybuilding experience.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xs tracking-[0.2em] text-[#D4AF37] mb-6 font-semibold uppercase">
              Programs
            </h4>
            <div className="space-y-3">
              <Link to="/programs" className="block text-sm text-white/60 hover:text-white transition-colors">
                Lifestyle Coaching
              </Link>
              <Link to="/programs" className="block text-sm text-white/60 hover:text-white transition-colors">
                Competition Prep
              </Link>
              <Link to="/programs" className="block text-sm text-white/60 hover:text-white transition-colors">
                Elite VIP Coaching
              </Link>
            </div>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-xs tracking-[0.2em] text-[#D4AF37] mb-6 font-semibold uppercase">
              Company
            </h4>
            <div className="space-y-3">
              <Link to="/gallery" className="block text-sm text-white/60 hover:text-white transition-colors">
                Transformations
              </Link>
              <Link to="/assessment" className="block text-sm text-white/60 hover:text-white transition-colors">
                Apply for Coaching
              </Link>
              <Link to="/contact" className="block text-sm text-white/60 hover:text-white transition-colors">
                Contact
              </Link>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs tracking-[0.2em] text-[#D4AF37] mb-6 font-semibold uppercase">
              Contact
            </h4>
            <div className="space-y-4">
              <a
                href="mailto:a.nutrition.on@gmail.com"
                className="flex items-center gap-3 text-sm text-white/60 hover:text-white transition-colors"
              >
                <Mail size={16} />
                a.nutrition.on@gmail.com
              </a>
              <a
                href="https://wa.me/16193876711"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-sm text-white/60 hover:text-white transition-colors"
              >
                <Phone size={16} />
                +1 (619) 387-6711
              </a>
              
              {/* Social Links */}
              <div className="flex gap-4 pt-4">
                <a
                  href="https://instagram.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 border border-white/20 flex items-center justify-center text-white/60 hover:text-[#D4AF37] hover:border-[#D4AF37] transition-colors"
                  data-testid="footer-instagram"
                >
                  <Instagram size={18} />
                </a>
                <a
                  href="https://youtube.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 border border-white/20 flex items-center justify-center text-white/60 hover:text-[#D4AF37] hover:border-[#D4AF37] transition-colors"
                  data-testid="footer-youtube"
                >
                  <Youtube size={18} />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-[#1A1A1A]">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/40 text-sm">
              © {new Date().getFullYear()} Camp Cormier Academy. All rights reserved.
            </p>
            <div className="flex gap-6">
              <a href="#" className="text-white/40 text-sm hover:text-white transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="text-white/40 text-sm hover:text-white transition-colors">
                Terms & Conditions
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
